import { computed } from "vue"
import { useStore } from "@/store";
import FuncoesHelper from "@/helpers/FuncoesHelper";

class ComponenteDadosAtendimentoService {
    setup() {
        const store = useStore()
        const dadosAtendimento = computed(() => store.state.dadosAtendimento)
        return { dadosAtendimento }
    }

    setupDadosPrestador() {
        const store = useStore();
        const dadosPrestador = computed(() => store.state.dadosPrestador);
        return { dadosPrestador }
    }

    trataDadosAtendimento(dadosAtendimento) {
        const trataEndereco = (tipo, dados) => {
            const { 
                logradouroOrigem, numeroOrigem, bairroOrigem, cidadeOrigem, estadoOrigem, logradouroDestino, numeroDestino, bairroDestino, cidadeDestino, estadoDestino
             } = dados;
        
            let enderecoCompleto = ''
            if (tipo === 'origem') {
                enderecoCompleto = [logradouroOrigem, numeroOrigem].filter(Boolean).join(', ') + ', ';
                enderecoCompleto += [bairroOrigem, cidadeOrigem].filter(Boolean).join(' - ') + ' - ';
                enderecoCompleto += estadoOrigem ?? ''
            } else {
                enderecoCompleto = [logradouroDestino, numeroDestino].filter(Boolean).join(', ') + ', ';
                enderecoCompleto += [bairroDestino, cidadeDestino].filter(Boolean).join(' - ') + ' - ';
                enderecoCompleto += estadoDestino ?? ''
            }
            return enderecoCompleto.toUpperCase()
        }

        dadosAtendimento.enderecoOrigem = trataEndereco('origem', dadosAtendimento);
        dadosAtendimento.enderecoDestino = trataEndereco('destino', dadosAtendimento);
        dadosAtendimento.dataAtendimento = FuncoesHelper.dataPt(dadosAtendimento.dataAtendimento);
        dadosAtendimento.dataAgendamento = FuncoesHelper.dataPt(dadosAtendimento.dataAgendamento);
        dadosAtendimento.telefoneSolicitante = FuncoesHelper.formatarTelefone(dadosAtendimento.telefoneSolicitante);
        
        delete dadosAtendimento.logradouroOrigem;
        delete dadosAtendimento.numeroOrigem;
        delete dadosAtendimento.bairroOrigem;
        delete dadosAtendimento.cidadeOrigem;
        delete dadosAtendimento.estadoOrigem;
        delete dadosAtendimento.logradouroDestino;
        delete dadosAtendimento.numeroDestino;
        delete dadosAtendimento.bairroDestino;
        delete dadosAtendimento.cidadeDestino;
        delete dadosAtendimento.estadoDestino;
        
        return dadosAtendimento
    }
}

export default new ComponenteDadosAtendimentoService();